class grinderReadMore extends HTMLElement {
    constructor() {
        super(),
            setTimeout(() => {
                this.initListeners();
            }, 200);
    }
    initListeners() {
        this.addEventListener("click", () => {
            document.getElementById("tab-content-collapsed").classList.toggle("active"),
                document.getElementById("tab-content-collapsed").classList.contains("active")
                    ? (document.querySelector(".tab-content-read-more").innerHTML = "Read Less")
                    : (document.querySelector(".tab-content-read-more").innerHTML = "Read More"),
                this.classList.contains("scroll_to_heading") &&
                    document
                        .getElementById("tab-content-collapsed")
                        .scrollIntoView({ behavior: "smooth", block: "center" });
        });
    }
}
window.customElements.define("grinder-col-read-more", grinderReadMore);

(() => {
    var __webpack_exports__ = {};
    window.PXUTheme.jsSidebar = {
        init: function () {
            const facetedFilterForm = document.querySelector("[data-faceted-filter-form]");
            facetedFilterForm &&
                facetedFilterForm.addEventListener("change", (e) => {
                    e.target.type != "number" && facetedFilterForm.submit();
                }),
                document.querySelectorAll('[data-sidebar-block__toggle="open"]').forEach(function (block) {
                    window.PXUTheme.jsSidebar.openSidebarBlock($(block));
                }),
                $("[data-has-toggle-option]").on("click", '[data-sidebar-block__toggle="closed"]', function (e) {
                    e.preventDefault(), window.PXUTheme.jsSidebar.openSidebarBlock($(this));
                }),
                $("[data-has-toggle-option]").on("click", '[data-sidebar-block__toggle="open"]', function (e) {
                    e.preventDefault(), window.PXUTheme.jsSidebar.closeSidebarBlock($(this));
                }),
                $("[data-product-sidebar]").length
                    ? ($(".section--has-sidebar-option").addClass("has-sidebar-enabled"),
                      $(".section--has-sidebar-option").removeClass("has-sidebar-disabled"))
                    : ($(".section--has-sidebar-option").removeClass("has-sidebar-enabled"),
                      $(".section--has-sidebar-option").addClass("has-sidebar-disabled"));
        },
        openSidebarBlock: function ($toggleBtn) {
            const $parentBlock = $toggleBtn.closest(".sidebar__block"),
                $toggleIcon = $toggleBtn.find(".icon");
            $toggleBtn.attr("data-sidebar-block__toggle", "open"),
                $parentBlock.addClass("is-active"),
                $parentBlock.attr("aria-expanded", !0),
                $parentBlock.find("[data-sidebar-block__content--collapsible]").slideDown();
        },
        closeSidebarBlock: function ($toggleBtn) {
            const $parentBlock = $toggleBtn.closest(".sidebar__block"),
                $toggleIcon = $toggleBtn.find(".icon");
            $toggleBtn.attr("data-sidebar-block__toggle", "closed"),
                $parentBlock.removeClass("is-active"),
                $parentBlock.attr("aria-expanded", !1),
                $parentBlock.find("[data-sidebar-block__content--collapsible]").slideUp();
        },
        unload: function () {
            $("[data-sidebar-block__toggle]").off();
        },
    };
})();
